import type { TrackableValue } from './TrackableValue'

export class ReactiveValue<T> implements TrackableValue<T> {
  private rawvalue: T
  private listeners: ((value: T) => void)[] = []
  private handleListenerError = (error: any) => {
    console.error('Error in listener', error)
  }

  constructor(value: T, handleListenerError?: (error: any) => void) {
    this.rawvalue = value
    if (handleListenerError) {
      this.handleListenerError = handleListenerError
    }
  }

  get value() {
    return this.rawvalue
  }

  [Symbol.dispose]() {}

  checkEqual = (a: T, b: T) => a === b

  update(updater: (value: T) => T) {
    const newValue = updater(this.rawvalue)
    if (this.checkEqual(newValue, this.rawvalue)) return
    this.rawvalue = newValue
    this.listeners.forEach(l => {
      try {
        l(this.rawvalue)
      } catch (error) {
        this.handleListenerError(error)
      }
    })
  }

  listen(listener: (value: T) => void) {
    this.listeners.push(listener)
    return {
      [Symbol.dispose]: () => {
        this.listeners = this.listeners.filter(l => l !== listener)
      },
    }
  }

  sync(listener: (value: T) => void) {
    try {
      listener(this.rawvalue)
    } catch (error) {
      this.handleListenerError(error)
    }
    return this.listen(listener)
  }
}
